import { InjectionToken } from '@angular/core';

export interface FilterType {
  name: string;
  component: any;
}

export const FILTER_TYPE = new InjectionToken<FilterType>('ADM_FILTER_TYPES');
